/* eslint-disable @angular-eslint/component-class-suffix */
/* eslint-disable @angular-eslint/component-selector */
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Input,
} from '@angular/core';

type Color = 'default' | 'primary';
type Size = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
type HoverShape = 'square' | 'circle';

@Component({
    selector: '[luiIconButton]',
    template: `
    <span matRipple class="lui-icon-btn-touch-container">
      <ng-content></ng-content>
    </span>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'iconButton',
    standalone: false
})
export class IconButton {
  private _model = 'lui-icon-btn';
  @HostBinding('class') get hostClasses() {
    return {
      [`${this._model}`]: true,
      [`${this._model}-primary`]: this.color === 'primary',
      [`${this._model}-${this.size}`]: true,
      [`${this._model}-hover-${this.hoverShape}`]: true,
    };
  }

  @Input() color: Color = 'default';
  @Input() size: Size = 'md';
  @Input() hoverShape: HoverShape = 'circle';

  constructor(public elementRef: ElementRef) {}
}
